/* eslint-disable no-nested-ternary */
import { useDispatch } from 'react-redux';
import { modalModel } from 'entities/modal';
import { useBreakpoints } from 'shared';

import { CratCircleDesktop } from './crat-circle.desktop';
import { CratCircleMobile } from './crat-circle.mobile';
import { CratCircleProps, OpenModalActionType } from './crat-circle.types';

export const CratCircle = ({ sx }: Omit<CratCircleProps, 'onButtonClick'>) => {
  const dispatch = useDispatch();
  const { isDownSmLayout } = useBreakpoints();

  const openModal = (type: OpenModalActionType) => {
    dispatch(
      modalModel.actions.openModal({
        type,
      }),
    );
  };

  return isDownSmLayout ? (
    <CratCircleMobile sx={{ ...sx }} onButtonClick={openModal} />
  ) : (
    <CratCircleDesktop sx={{ ...sx }} onButtonClick={openModal} />
  );
};
